<ds-modal
  [id]="modalId"
  [maxWidth]="800"
  [closeOthers]="true"
  [showCloseButton]="false"
  (onCloseModalEvent)="handleClose()"
>
  <div>
    <h1 dsContent [contentPath]="'billing.phoenixPayment.timeoutModal.title'"></h1>
    <span dsContent [contentPath]="'billing.phoenixPayment.timeoutModal.content1'"></span>
    <span class="timeLeft">
      <span dsContent [contentPath]="'billing.phoenixPayment.timeoutModal.content2'"></span>
      <b>{{ timeLeftString$ | async }}</b>
    </span>
  </div>
  <call-to-action
    [primaryButtonName]="continueCopy"
    (primaryEvent)="handleContinue()"
    [secondaryButtonName]="exitCopy"
    (secondaryEvent)="handleExit()"
    [equalWidthButtons]="true"
  ></call-to-action>
</ds-modal>
